// extracted by mini-css-extract-plugin
module.exports = {"container":"waveform-canvas_container__Y1Eoj","canvas":"waveform-canvas_canvas__Yo397","skeleton_animate":"waveform-canvas_skeleton_animate__sxJId"};